<template>
  <modal
    v-slot="{ data }"
    name="menuItem"
    :display-header-title="false"
    @closed="resetSelectionHandler"
  >
    <menu-item
      :is-read-only="data.isReadOnly"
      @reset-handler="resetSelectionHandler"
    />
  </modal>
</template>


<script>
  import { mapGetters } from 'vuex';

  import events from '@/services/events';

  import MenuItem from './menu-item/index.vue';


  export default {
    name: 'MenuItemModal',

    components: {
      MenuItem
    },

    computed: {
      ...mapGetters('menu', ['selectedItem'])
    },

    methods: {
      resetSelectionHandler() {
        /** Note:
         * If user is viewing the details via the modal on any other page (cart, upsell, etc...), then reset selection on close.
         */
        this.$closeModal('menuItem');

        this.$store.dispatch('menu/selectItem');

        this.$store.dispatch('menu/selectCategory');

        /** Note:
         * Need to emit event so the menu view details will re-route accordingly if user is viewing the detail route.
         * See: menu-item-detail-page.vue,
         */
        events.emit('menu-item-modal:close');
      }
    }
  };
</script>
